<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Categoria de Plano</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar Filtro"
              @click="ResetListMerchantPlan()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">
                  Planos
                </h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-0">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis col-lg-12"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar Relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-12" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0">Codigo</th>
                    <th scope="col" class="border-0 ">Nome do Plano</th>
                    <th scope="col" class="border-0">
                      Adesões / Limite
                    </th>
                    <th scope="col" class="border-0">
                      Valor
                    </th>
                    <th scope="col" class="border-0">
                      Intervalo
                    </th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(MerchantPlan, index) in MerchantPlans" :key="index">
                    <td>{{ MerchantPlan.Id }}</td>
                    <td>{{ MerchantPlan.Name }}</td>
                    <td>
                      {{ MerchantPlan.SubscriptionLimit != null ? MerchantPlan.SubscriptionLimit : "∞" }} /
                      {{ MerchantPlan.SubscriptionTax != null ? MerchantPlan.SubscriptionTax : "∞" }}
                    </td>
                    <td>{{ MerchantPlan.Amount != 0 ? MerchantPlan.Amount : "-" | currency }}</td>
                    <td>{{ MerchantPlan.PlanFrequence.Name != null ? MerchantPlan.PlanFrequence.Name : "-" }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('Plan', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenMerchantPlans($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Subscription', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenMerchantPlansAssinaturas($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Assinaturas vinculadas
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="MerchantPlans == undefined || MerchantPlans == null || MerchantPlans.length == 0">
                    <td colspan="6">Sem Registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      id="mFormMerchantPlans"
    >
      <!-- Loader -->

      <nav class="nav-steps" aria-label="breadcrumb">
        <ol style="background-color:#fff; padding: 0rem 0rem;" class="breadcrumb">
          <li class="breadcrumb-item">
            <a class="black-text" href="#" v-on:click="GoToStep($event, 0)" :class="[mCurrentStep == 0 ? 'active' : '']">
              Dados do plano
            </a>
            <div class="fas fa-angle-right mx-2"></div>
            <a class="black-text" href="#" v-on:click="GoToStep($event, 1)" :class="[mCurrentStep == 1 ? 'active' : '']">
              Configurações
            </a>
            <div class="fas fa-angle-right mx-2"></div>
            <a class="black-text" href="#" v-on:click="GoToStep($event, 2)" :class="[mCurrentStep == 2 ? 'active' : '']">
              Configurações de Boleto
            </a>
          </li>
        </ol>
      </nav>

      <d-form-row>
        <template v-if="mCurrentStep === 0 && !loadingTransaction">
          <d-col md="12" class="form-group"> </d-col>
          <d-col v-if="pOpened != null" md="4" class="form-group">
            <label>Nome</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="true"
              type="text"
              v-model="infoMerchantPlan.Name"
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Descrição</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.Description"
            />
          </d-col>

          <d-col md="4" class="form-group">
            <label>Intervalo de cobrança</label>
            <d-select
              v-if="infoMerchantPlan.PlanFrequence"
              :disabled="isSeeing"
              id="PlanFrequence"
              :value="1"
              class="custom-select"
            >
              <option :value="1" selected>{{ infoMerchantPlan.PlanFrequence.Name }}</option>
            </d-select>
          </d-col>
          <d-col md="4" class="form-group">
            <label>Data de expiração</label>
            <date-field
              v-if="isSeeing && new Date(infoMerchantPlan.ExpirationDate) > new Date('1900-01-01')"
              :disabled="isSeeing"
              format="dd/MM/yyyy"
              v-model="infoMerchantPlan.ExpirationDate"
            ></date-field>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              :value="'-'"
              v-else
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Valor</label>
            <currency-input class="form-control" :disabled="isSeeing" type="text" v-model="infoMerchantPlan.Amount" />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Taxa de adesão</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.SubscriptionTax"
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Dia de Geração da Cobrança</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.ChargeDay"
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Limite máximo de adesões</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.SubscriptionLimit"
            />
          </d-col>
        </template>

        <template v-if="mCurrentStep === 1 && !loadingTransaction">
          <d-col md="12" class="form-group"> </d-col>
          <d-col v-if="pOpened != null" md="6" class="form-group">
            <label>Dias para inadiplência</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="true"
              type="text"
              v-model="infoMerchantPlan.DaysChurn"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Dias alerta cobrança</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.DaysDelayAlert"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Dias alerta inadiplência</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.DaysChurnAlert"
            />
          </d-col>
          <d-col md="12" class="form-group">
            <d-form-checkbox v-model="infoMerchantPlan.IsChargeOverdue" v-bind:disabled="isSeeing"
              >Manter cobrança após inadiplência</d-form-checkbox
            >
          </d-col>
        </template>

        <template v-if="mCurrentStep === 2 && !loadingTransaction">
          <d-col md="12" class="form-group"> </d-col>
          <d-col v-if="pOpened != null" md="6" class="form-group">
            <label>Juros</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="true"
              type="text"
              v-model="infoMerchantPlan.PenaltyAmount"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Multa</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.InterestAmount"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Dia vencimento de boleto</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.DaysDue"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Tipo de valor</label>
            <d-select
              id="DiscountType"
              :disabled="isSeeing"
              v-model="infoMerchantPlan.DiscountType"
              :value="0"
              class="custom-select"
            >
              <option :value="0" selected>Não Definido</option>
              <option :value="1" selected>Valor</option>
              <option :value="2" selected>Percentual</option>
            </d-select>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Valor do desconto</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.DiscountAmount"
            />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Dia limite de desconto</label>
            <d-form-input
              :class="validatedMerchantPlansForm"
              :disabled="isSeeing"
              type="text"
              v-model="infoMerchantPlan.IsDiscount"
            />
          </d-col>
        </template>
      </d-form-row>

      <template slot="modal-footer">
        <b-button size="sm" class="btn btn-secondary" @click="BackStep()" :disabled="mCurrentStep === 0">
          <i class="fas fa-arrow-left"></i>
        </b-button>

        <b-button size="sm" class="btn btn-secondary" @click="ProcessNextStep()" :disabled="mCurrentStep === 2">
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mSubscription"
      title="Assinaturas"
    >
      <div class="card-body p-0 pb-3 text-center">
        <loader :is-loading="loadingList"></loader>
        <table class="table " v-if="!loadingList">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th scope="col" class="border-0">Assinaturas</th>
              <th scope="col" class="border-0 ">Plano</th>
              <th scope="col" class="border-0">
                Forma de pagamento
              </th>
              <th scope="col" class="border-0">
                Name
              </th>
              <th scope="col" class="border-0">
                Status da Assinatura
              </th>
              <th scope="col" class="border-0">
                Data da Assinatura
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(Subscription, index) in Subscriptions" :key="index">
              <td>{{ Subscription.Id }}</td>
              <td>{{ Subscription.Plan.Name }}</td>
              <td>{{ Subscription.PaymentMethod.Name }}</td>
              <td>{{ Subscription.Customer.Name }}</td>
              <td>
                <span class="label rounded" :class="Subscription | SubscriptionStatusColor">
                  {{ Subscription | SubscriptionStatusText }}
                </span>
              </td>
              <td>{{ Subscription.CreatedDate | date }}</td>
            </tr>
          </tbody>
          <tr v-if="Subscriptions == undefined || Subscriptions == null || Subscriptions.length == 0">
            <td colspan="6">Sem Registros</td>
          </tr>
        </table>
      </div>
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" centered id="mFilter" title="Filtros">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Nome</label>
          <input class="form-control" type="text" v-model="filter.Name" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Status</label>
          <d-select size="sm" v-model="filter.IsEnabled">
            <option :value="false">Inativos</option>
            <option :value="true">Ativos</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button @click="Filter()" class="btn btn-primary" title="Pesquisar" v-b-tooltip.hover.bottom variant="primary">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";
import dateField from "../common/date-field";

export default {
  name: "MerchantPlan",
  components: {
    dateField,
    decimalField
  },
  ListMerchantPlan: [],
  data: function() {
    return {
      mCurrentStep: 0,
      modalTitle: "Novo Campo",
      modalTitleAss: "Novo Campo 2",
      labelName: "Controller",
      MerchantPlans: [],
      Types: [],
      MerchantPlan: [],
      Subscription: [],
      Subscriptions: [],
      disabled: 0,
      countFilter: 0,
      idMerchantPlans: 0,
      selected_MerchantPlans: [],
      MerchantPlans_list: [],
      step: 0,
      infoMerchantPlan: {
        Code: null,
        Id: null,
        IdMerchant: null,
        PlanFrequence: {
          Code: null,
          Name: undefined
        },
        IdPlanFrequence: null,
        Name: null,
        Description: null,
        Amount: null,
        SubscriptionTax: null,
        SubscriptionLimit: null,
        ChargeDay: null,
        DaysChurn: null,
        DaysChurnAlert: null,
        DaysDelayAlert: null,
        DaysTrial: null,
        IsEnabled: null,
        IsProRata: null,
        IsImmediateCharge: null,
        IsChargeOverdue: null,
        CallbackUrl: null,
        ExpirationDate: null,
        DaysDue: null,
        DaysBeforeCancel: null,
        Instruction: null,
        PenaltyAmount: null,
        InterestAmount: null,
        Message: null,
        CreatedDate: null,
        Meta: null,
        PlanHash: null,
        DiscountType: null,
        DiscountDue: null,
        DiscountAmount: null,
        DayProRata: null,
        IsCustomizableDueDate: null
      },
      filter: {
        Code: null,
        Name: null,
        IsEnabled: null
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      validatedMerchantPlansForm: false,
      loadingTransaction: false,

      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10
      },
      window: {
        width: 0,
        height: 0
      },
      mSteps: ["Dados do plano", "Configurações", "Configurações do Boleto"]
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListMerchantPlan();
    },
    "pagination.RowsPerPage": function() {
      this.ListMerchantPlan();
    }
  },
  mounted() {
    if (this.$route.params.idMerchant !== null && this.$route.params.idMerchant !== undefined) {
      this.idMerchant = this.$route.params.idMerchant;
    }
    this.ListMerchantPlan();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantPlan();
    },
    GoToStep: function(e, stepToGo) {
      e.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    ProcessNextStep: function(nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
    },
    NextStep: function() {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        this.mCurrentStep += 1;
      }
    },
    BackStep: function() {
      if (this.mCurrentStep >= 1) {
        this.mCurrentStep -= 1;
      }
    },
    ResetFilter: function() {
      this.filter = {
        Code: null,
        Name: null,
        IsEnabled: null
      };
    },

    OpenMerchantPlans: function(e, index, view) {
      e.preventDefault();
      this.validatedMerchantPlansForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoMerchantPlan();

      // View
      this.modalTitle = "Visualização";
      this.pOpened = index;
      this.isSeeing = true;
      this.mCurrentStep = 0;

      this.GetMerchantPlan(this.MerchantPlans[index].Id);

      this.$bvModal.show("mFormMerchantPlans");
    },
    OpenMerchantPlansAssinaturas: function(e, index, view) {
      this.$bvModal.show("mSubscription");
      e.preventDefault();
      this.validatedMerchantPlansForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoMerchantPlan();

      // View
      this.modalTitleAss = "Visualizar as assinaturas vinculadas ao plano";
      this.pOpened = index;
      this.isSeeing = true;

      this.ListSubscription(this.idMerchant, this.MerchantPlans[index].Id);
    },

    GetMerchantPlan: function(id) {
      this.loadingModal = true;
      if (this.id != 0) {
        this.$store
          .dispatch("GetMerchantPlan", { id: id, idMerchant: this.idMerchant })
          .then(response => {
            this.infoMerchantPlan = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListSubscription: function(idMerchant, idPlan) {
      this.countFilter = 0;
      this.loadingModal = true;

      const data = {
        ...this.pagination,
        "Object.Plan.Merchant.Id": idMerchant,
        "Object.Plan.Id": idPlan
      };
      if (this.id != 0) {
        this.$store
          .dispatch("ListMerchantSubscription", data)
          .then(response => {
            this.Subscriptions = response.Objects;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetParamsData: function(idMerchant, deletePagination = false) {
      this.loadingParamsData = true;
      var infoMerchantPlan = [];

      if (deletePagination)
        if (Object.keys(this.infoMerchantPlan).length > 0) {
          for (let key in this.infoMerchantPlan) {
            var keyValue = this.infoMerchantPlan[key];
            if (keyValue != null && keyValue != "undefined") {
              if (keyValue == true) infoMerchantPlan.push(key);
            }
          }
        }

      let data = {
        ...this.pagination,
        Code: this.filter.Code,
        IsEnabled: this.filter.IsEnabled,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.IsEnabled": this.filter.IsEnabled,
        "Object.Merchant.Id": this.idMerchant,
        "Object.SubscriptionTax": this.filter.SubscriptionTax,
        "Object.SubscriptionLimit": this.filter.SubscriptionLimit,
        "Object.Amount": this.filter.Amount
      };

      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchantPlan", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetListMerchantPlan: function() {
      this.ResetFilter();
      this.ListMerchantPlan();
    },
    ResetInfoMerchantPlan: function() {
      this.infoMerchantPlan = {
        Code: null,
        IdMerchant: null,
        IdPlanFrequence: null,
        Name: null,
        Description: null,
        Amount: null,
        SubscriptionTax: null,
        SubscriptionLimit: null,
        ChargeDay: null,
        DaysChurn: null,
        DaysChurnAlert: null,
        DaysDelayAlert: null,
        DaysTrial: null,
        IsProRata: null,
        IsImmediateCharge: null,
        IsChargeOverdue: null,
        CallbackUrl: null,
        ExpirationDate: null,
        DaysDue: null,
        DaysBeforeCancel: null,
        Instruction: null,
        PenaltyAmount: null,
        InterestAmount: null,
        Message: null,
        CreatedDate: null,
        Meta: null,
        PlanHash: null,
        DiscountType: null,
        DiscountDue: null,
        DiscountAmount: null,
        DayProRata: null,
        IsCustomizableDueDate: null
      };
    },
    ListMerchantPlan: function(idMerchant) {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.Amount)) this.countFilter++;
      if (hasValue(this.filter.SubscriptionTax)) this.countFilter++;
      if (hasValue(this.filter.SubscriptionLimit)) this.countFilter++;
      if (hasValue(this.filter.Description)) this.countFilter++;
      // if (hasValue(this.filter.IsEnabled)) this.countFilter++;

      this.loading = true;
      let params = this.GetParamsData(idMerchant);
      this.$store
        .dispatch("ListMerchantPlans", { params: params })
        .then(response => {
          this.MerchantPlans = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },

    preventDecimal(e) {
      if (e.Code == "Comma" || e.Code == "Period" || e.Code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
td {
  padding: 10px;
}
.tdEspaco {
  display: table;
  float: left;
  margin-right: 10px;
}
table {
  border-spacing: 5px;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/merchantPlan.vue